//课程分享确认
import React from 'react';

export default class courseIndex extends React.Component {
	constructor(props){
		super(props)
		this.state = {
			merchandiseId: ''
		};
	}
	componentDidMount(props) {
		// var code = this.GetQueryString("code");

		// if (code == "" || code == null || code == undefined) {
		// 	let url = this.urlencode(window.location.href);
		// 	//let url = this.urlencode('http://ptt.zlgxt.cn/h5/index.html?#/teacher');
		// 	let WXurl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx2ac90c6545e0135e&redirect_uri="+ url +"&response_type=code&scope=snsapi_base&state=1#wechat_redirect";
		// 	window.location.href = WXurl;
		// 	return
		// }
		// //orgId=2 & merchandiseId=4 & txTime=1606904009
		// var merchandiseId = this.GetQueryString("merchandiseId");
		
		
		
		// function isIos () {
		//     var u = navigator.userAgent;
			
		//     if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
		// 		//安卓手机
		//         //return "Android";
		//         return false
		//     } else if (u.indexOf('iPhone') > -1) {
		// 		//苹果手机
		//         //return "iPhone";
		//         return true
		//     }
		// }
		
		// var isiOS = isIos ();
		
		// if (isiOS) {
		// 	console.log("iPhone")
		// 	document.getElementById('download-app').value = 'itms-services:///?action=download-manifest&url=https://jnt.jianongzhenghe.com:9003/PTTOnline.ipa/manifest.plist';
		// } else {
		// 	console.log("Android")
		// 	document.getElementById('download-app').value = 'http://jd.com/8JZ5OO';
		// }
		
		// //已下载打开APP 未下载跳转到input的value也就是下载页面
		// //scheme_IOS和scheme_Adr这两个参数是app端给的呼起app url。
		
		// var ua = navigator.userAgent.toLowerCase();
		// var t;
		// var config = {
		// 	//scheme:必须	
		// 	scheme_IOS: 'pttonline2020://com.lababox',
		// 	//scheme_IOS: 'lbbox1214151904://com.lababox',
		// 	scheme_Adr: 'schemedemo://aa.com/test/scheme?name=google&page=1',
		// 	download_url: document.getElementById('download-app').value,
		// 	timeout: 200
		// };
		
		// function openclient() {
		// 	console.log("iPhone2")
			
		// 	var startTime = Date.now();
		// 	var ifr = document.createElement('iframe');
			
		// 	console.log(ua)
		
		// 	ifr.src = ua.indexOf('os') > 0 ? config.scheme_IOS : config.scheme_Adr;
			
		// 	console.log(ifr.src)
			
		// 	ifr.style.display = 'none';
		// 	document.body.appendChild(ifr);
		
		// 	var t = setInterval(function() {
		// 		var endTime = Date.now();
		
		// 		if (!startTime || endTime - startTime < config.timeout + 200) {
		// 			window.location = config.download_url;
		// 			alert(1)
		// 		} else {
		// 			alert(2)
		// 		}
		// 	}, config.timeout);
		
		// 	window.onblur = function() {
		// 		clearTimeout(t);
		// 	}
		// }
		// //window.addEventListener("click", function() {
		// 	document.getElementById("call-app").addEventListener('click', openclient, false);
		//}, false);
	}
	zhuan(){
		console.log(1)
		//let url = 'pttonline2020://'; // codingapi://finger /
		//let url = 'https://www.baidu.com';
		var timeout, t = 1000, hasApp = true;
		
		var u = navigator.userAgent;
		var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
		var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
				
		setTimeout(function () {
			if (!hasApp) {
			//未安装app
			  if(isAndroid){
				alert("检测到您未安装，请先安装");
				window.location.href = "http://aapp.zlgxt.cn/qmwd";
			  }else{
				alert("您的设备赞不支持");
				window.location.href =  "itms-services:///?action=download-manifest&url=https://jnt.jianongzhenghe.com:9003/PTTOnline.ipa/manifest.plist";
			  } 
			}
			//document.body.removeChild(ifr);
		}, 2000);
		
		var t1 = Date.now();
		timeout = setTimeout(function () {
			  var t2 = Date.now();
			  if (!t1 || t2 - t1 < t + 100) {
				if(isAndroid){
					alert("安卓设备打开");
					window.location.href =  'ylbb://ylbb.com:80/params?p=6&id=7';
				}else{
					alert("苹果设备打开");
					window.location.href =  'pttonline2020://p=6&id=7';
				}  
				hasApp = false;
			  }
		}, t);
	}
	GetQueryString(name) {
		//获取链接所带参数
		var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
		var r = window.location.search.substr(1).match(reg);
		if (r != null) return r[2];
		return null;
	}
	urlencode(str) {
		//转码
		str = (str + '').toString();
		return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').
		replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
	}
	componentWillUnmount(){
    	//界面离开的时候
		this.setState = (state, callback)=>{
			return;
		}
	}
	
	render() {
		return(
			<div>
				<div>请用默认浏览器打开</div>
				<div >
					<input id="download-app" type="hidden" name="storeurl" value="itms-services:///?action=download-manifest&url=https://jnt.jianongzhenghe.com:9003/PTTOnline.ipa/manifest.plist" />
					<div className={"intoR"}>
						<span>立即进入1</span>
					</div>
				</div>
				&nbsp;
				<div id="call-app">
					<span onClick={this.zhuan.bind(this)}>立即进入</span>
				</div>
			</div>
		);
	}
}